import { isEncryptedField, toEncryptedPayload } from '@/infra/crypto/payloads'
import type { DecryptFn } from './types'

export const ENCRYPTED_PLACEHOLDER = '(encrypted)'

export const asRecordOrNull = (value: unknown): Record<string, unknown> | null =>
  typeof value === 'object' && value !== null && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null

export const asStringOrFallback = (value: unknown, fallback: string): string =>
  typeof value === 'string' ? value : fallback

export const tryDecryptRecord = async (
  field: unknown,
  keyVersion: number,
  decrypt: DecryptFn,
): Promise<Record<string, unknown> | null> => {
  if (!isEncryptedField(field)) return null
  const result = await decrypt(toEncryptedPayload(field, keyVersion))
  return asRecordOrNull(result)
}

export const tryDecryptString = async (
  field: unknown,
  keyVersion: number,
  decrypt: DecryptFn,
  fallback: string,
): Promise<string> => {
  if (!isEncryptedField(field)) return fallback
  const result = await decrypt(toEncryptedPayload(field, keyVersion))
  return asStringOrFallback(result, fallback)
}

export const isStringOrEncryptedField = (value: unknown): boolean =>
  typeof value === 'string' ||
  (typeof value === 'object' && value !== null && 'ciphertext' in value && 'iv' in value)
